import React from "react";
import {
    ActiveGamesIndicatorContainer,
    ActiveGamesIndicatorTypography,
    LiveDot,
} from "./ActiveGamesIndicator.styles";
import { useActiveGames } from "./useActiveGames";

export function ActiveGamesIndicator() {
    const isActive = useActiveGames();

    if (!isActive) {
        return <></>;
    }

    return (
        <ActiveGamesIndicatorContainer>
            <LiveDot />
            <ActiveGamesIndicatorTypography>
                Spiel live verfolgen und kommentieren
            </ActiveGamesIndicatorTypography>
        </ActiveGamesIndicatorContainer>
    );
}
